import { render, staticRenderFns } from "./PlatformAnalyticsSummary.vue?vue&type=template&id=97dfdafe&"
import script from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js&"
export * from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports